export const LAYOUT_TYPES = {
  AUTH: "AUTH",
  USER: "USER",
  VISITOR: "VISITOR",
  ADMIN: "ADMIN",
};
